"use client";

import { Text } from "@/components/ui/text";
import { TextProps } from "@/components/ui/text/text";
import { Icon, IconProps } from "@/components/ui/icon";
import { ArtDirection } from "@/components/util/art-direction";
import { Video } from "@/components/util/video";

import { useCardMedia, UseCardMediaProps } from "./use-card-media";

export type CardMediaProps = UseCardMediaProps;

function CardMedia(props: CardMediaProps) {
  const {
    styles,
    data: { title, description, link, media, legend },
    textSize,
    iconName,
    WrapperEL,
    isVideoBackground,
    hasCustomIcon,
    elementProps,
  } = useCardMedia(props);

  return (
    <article className={styles.base()}>
      <WrapperEL {...elementProps}>
        {legend && (
          <Text tag="span" size="labelSmall" className={styles.legend()}>
            {legend}
          </Text>
        )}

        <div className={styles.cardMediaWrapper()}>
          {hasCustomIcon && iconName && (
            <span className={styles.customIconWrapper()}>
              <Icon name={iconName as IconProps["name"]} className={styles.icon()} />
            </span>
          )}
          {isVideoBackground && (
            <Video
              className={styles.media()}
              containerClassName={styles.mediaWrapper()}
              src={media?.url || ""}
              mime={media?.mime || ""}
              autoPlay
              muted
              loop
              playsInline
            />
          )}
          <ArtDirection
            className={styles.media()}
            containerClassName={styles.mediaWrapper()}
            desktop={media}
          />
        </div>

        <div className={styles.content()}>
          {title && (
            <Text
              tag="h4"
              size={textSize.title as TextProps["size"]}
              className={styles.title()}
            >
              {title}
            </Text>
          )}
          {description && (
            <Text
              size={textSize.description as TextProps["size"]}
              className={styles.description()}
            >
              {description}
            </Text>
          )}
          {iconName && (
            <span className={styles.iconWrapper()}>
              <Icon name={iconName as IconProps["name"]} className={styles.icon()} />
            </span>
          )}
        </div>
      </WrapperEL>
    </article>
  );
}

export default CardMedia;
